import { Component, computed, Signal } from '@angular/core';
import { AyenServices } from 'src/app/core/services/ayen-services/ayen-services.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-new-order',
    templateUrl: './new-order.component.html',
    styleUrls: ['./new-order.component.scss'],
    standalone: false
})
export class NewOrderComponent {
  selectedView!: string;
  orderId!: number;
  dynamicService: number | null = null;
  stepper: string = 'building';

  private featureFlags = toSignal(this.ayenServices.featureFlags$, { initialValue: null });
  
  isPropertyUnitEnabled: Signal<boolean> = computed(() => {
    const flags = this.featureFlags();
    if (!flags || !Array.isArray(flags)) return false;
    const flag = flags.find(item => item.key === 'ADMIN__PROPERY_UNIT');
    return flag?.is_enabled === true;
  });

  constructor(private ayenServices: AyenServices) {}

  getView(event: { view: string; id: number; dynamic_service?: number | null }) {
    this.selectedView = event.view;
    this.stepper = this.selectedView;
    this.orderId = event.id;
    if (event.dynamic_service !== undefined) {
      this.dynamicService = event.dynamic_service;
    }
  }
  
}
